import { render } from "./GeneralStats.vue?vue&type=template&id=32d63ca0"
import script from "./GeneralStats.vue?vue&type=script&lang=js"
export * from "./GeneralStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__